var map = {
	"./add.svg": 65228,
	"./arrow-down.svg": 51061,
	"./attach-file-icon.svg": 71839,
	"./back-arrow-green.svg": 61176,
	"./back-arrow-no-fill.svg": 13209,
	"./back-arrow-white.svg": 5563,
	"./back-arrow.svg": 22598,
	"./backup-icon.svg": 59215,
	"./block-white.svg": 48162,
	"./bookmark-off.svg": 94366,
	"./bookmark.svg": 52820,
	"./brush-icon.svg": 20979,
	"./calendar.svg": 24095,
	"./check-icon-white.svg": 3509,
	"./check-icon.svg": 85624,
	"./chevron-down.svg": 17897,
	"./chevron-up.svg": 46287,
	"./circle.svg": 35340,
	"./clock.svg": 50993,
	"./close-icon-gray.svg": 90973,
	"./close-icon.svg": 66191,
	"./comment-icon.svg": 86536,
	"./copy-icon-black.svg": 53467,
	"./copy-icon.svg": 19398,
	"./delete.svg": 57219,
	"./down-arrow-fill.svg": 8197,
	"./down-arrow.svg": 13009,
	"./download-icon.svg": 35857,
	"./download.svg": 73146,
	"./drag.svg": 10194,
	"./edit.svg": 53881,
	"./emoji-icon.svg": 60580,
	"./eye-icon.svg": 94400,
	"./feedback.svg": 90632,
	"./filter.svg": 12932,
	"./format-bold.svg": 97912,
	"./format-bullet-list.svg": 95054,
	"./format-code.svg": 14407,
	"./format-indent-decrease.svg": 44836,
	"./format-indent-increase.svg": 8710,
	"./format-italic.svg": 2322,
	"./format-numbered-list.svg": 91626,
	"./format-quote.svg": 85263,
	"./format-strike.svg": 96698,
	"./format-title.svg": 85977,
	"./graphic-icon.svg": 30877,
	"./group-icon.svg": 69386,
	"./hamburger-icon.svg": 75928,
	"./happy-face.svg": 24920,
	"./heavy-plus.svg": 48866,
	"./info-icon.svg": 8156,
	"./instructions-icon.svg": 68946,
	"./left-arrow.svg": 24034,
	"./library-add.svg": 70226,
	"./link-icon.svg": 27791,
	"./loader.svg": 20950,
	"./metrics-icon.svg": 95721,
	"./notes-icon.svg": 43633,
	"./notifications-off.svg": 98906,
	"./notifications.svg": 70919,
	"./open-external-icon.svg": 61051,
	"./open-icon.svg": 38624,
	"./pencil.svg": 56211,
	"./person-add.svg": 82087,
	"./plus-purple.svg": 37842,
	"./plus.svg": 68970,
	"./ready.svg": 40947,
	"./redo-icon.svg": 67871,
	"./repeat-icon.svg": 75497,
	"./right-arrow.svg": 18179,
	"./search.svg": 30223,
	"./send.svg": 66105,
	"./settings-icon-purple.svg": 66993,
	"./settings-icon.svg": 94451,
	"./social/facebook.svg": 95126,
	"./social/github.svg": 56122,
	"./social/instagram.svg": 23746,
	"./social/linkedin.svg": 94955,
	"./social/twitter.svg": 53597,
	"./sort.svg": 22196,
	"./spin.svg": 72840,
	"./tag.svg": 24478,
	"./team-members-icon.svg": 7782,
	"./team-mutes-icon.svg": 22847,
	"./teams.svg": 57532,
	"./template.svg": 57675,
	"./three-dots.svg": 92337,
	"./translate.svg": 46975,
	"./undo-icon.svg": 86,
	"./unfold-less.svg": 49310,
	"./unfold-more.svg": 917,
	"./unread-message-icon.svg": 46513,
	"./up-arrow-fill.svg": 60670,
	"./upload-icon.svg": 13652,
	"./vertical_points.svg": 44981,
	"./videoconf-icon.svg": 48827,
	"./warning.svg": 11951,
	"./zoom-minus-icon.svg": 61418,
	"./zoom-plus-icon.svg": 63300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33739;